import {ValueObject} from '@s-ui/domain'

import {CheckOpenHoursCustomerCareError} from '../Errors/CheckOpenHoursCustomerCareError.js'

export class DateValueObject extends ValueObject {
  /**
   * @constructor
   * @param {Object} data
   * @param {String} data.date
   */

  /**
   * Validation method
   */
  static validate({date}) {
    const _date = new Date(date)

    if (!Object.prototype.toString.call(_date) === '[object Date]' || isNaN(_date.getTime())) {
      throw new CheckOpenHoursCustomerCareError('Invalid date object.')
    }
  }
}
